// RentalManagementArticle.tsx
import { useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../material-icon";
import { colorPalette } from "../../../utils/theme";
import useIsMobile from "../../../hooks/useIsMobile";
import { ArticleImage, ArticleTitle, ArticleSubtitle, SharingContainer, ArticleDescription, Headline, ThreeDots, ArticleText, FilterContainer, AuthorName, SubHeadline, ArticleImageContainer } from "../article.styles";
import RentalManagementImage from "../../../assets/images/articles/rental-management-large.webp";
import RentalManagementMobileImage from "../../../assets/images/articles/rental-management.webp";
import Filter from "../../filter/filter";
import { useTranslation } from 'react-i18next';

interface RentalManagementArticleProps {
    onClickShare: () => void;
}

const RentalManagementArticle: React.FC<RentalManagementArticleProps> = ({ onClickShare }) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    const renderHeaderContent = useCallback(() => {
        return (
            <ArticleImageContainer>
                <ArticleImage
                    src={isMobile ? RentalManagementMobileImage : RentalManagementImage}
                    alt="Article Thumbnail"
                    showBorderRadius={!isMobile}
                />
            </ArticleImageContainer>
        );
    }, []);

    return (
        <>
            {isMobile && (
                renderHeaderContent()
            )}

            <Row className="justify-content-center flex-grow-1" style={{ paddingLeft: 16, paddingRight: 16 }}>
                <Col xs={12} lg={8} xl={6}>
                    <ArticleTitle>{t("articles.rental_management.title")}</ArticleTitle>
                    <ArticleSubtitle>{t("articles.rental_management.subtitle")}</ArticleSubtitle>

                    <SharingContainer>
                        <AuthorName>Managd Knowledge Hub</AuthorName>
                        <MaterialIcon icon="share" size={24} color={colorPalette.textDark} onClick={onClickShare} />
                    </SharingContainer>

                    {!isMobile && (
                        renderHeaderContent()
                    )}

                    <ArticleDescription>{t("articles.rental_management.intro")}</ArticleDescription>

                    <ThreeDots />

                    <Headline>{t("articles.rental_management.section_title")}</Headline>
                    <ArticleText>{t("articles.rental_management.section_text")}</ArticleText>

                    <SubHeadline>{t("articles.rental_management.section1_title")}</SubHeadline>
                    <ArticleText>{t("articles.rental_management.section1_text")}</ArticleText>

                    <SubHeadline>{t("articles.rental_management.section2_title")}</SubHeadline>
                    <ArticleText>{t("articles.rental_management.section2_text")}</ArticleText>

                    <SubHeadline>{t("articles.rental_management.section3_title")}</SubHeadline>
                    <ArticleText>{t("articles.rental_management.section3_text")}</ArticleText>


                    <SubHeadline>{t("articles.rental_management.section4_title")}</SubHeadline>
                    <ArticleText>{t("articles.rental_management.section4_text")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.rental_management.why_managd_title")}</Headline>
                    <ArticleText>{t("articles.rental_management.why_managd_text")}</ArticleText>
                    <ArticleText>{t("articles.rental_management.max_return")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.rental_management.conclusion_title")}</Headline>
                    <ArticleText>{t("articles.rental_management.conclusion_text")}</ArticleText>

                    {/*<FilterContainer>
                        <Filter label="Handover" disabled />
                        <Filter label="Mietverwaltung" disabled />
                        <Filter label="Services" disabled />
                    </FilterContainer>*/}
                </Col>
            </Row>
        </>
    );
};

export default RentalManagementArticle;
